module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-31-b9350fd31e1f8f0f60f6c9b1b5f60f71.png";